import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { getNiceDate } from '@iotv/datamodel-core';
import { isNonNaNNumber } from '@iotv/iotv-v3-types';
import { Box, Stack } from '@mui/material';
import { RowColumnExport } from '../../io/VerySimpleExport/RowColumnExport';
import { spreadsheetize } from '../Export/spreadsheetize';
const debug = process.env.REACT_APP_DEBUG && false;
/* @deprecated - unused
 * WARN: (ADH) if you want to revive this, make sure to re-enable dropped in GeofenceMetricsTable
 * */
export const CoverageTable = ({ coverageReport, showExport = true }) => {
    const { GeoObject, Networks, timePeriod, inBoundsResults, created } = coverageReport;
    return (_jsxs(Stack, { direction: 'column',
        sx: { maxWidth: '50rem', backgroundColor: 'white', borderStyle: 'solid', borderWidth: 1, borderRadius: 1, padding: 1, marginTop: 1 }, children: [_jsx(GeoObjectTable, { GeoObject, timePeriod, created }), Object.entries(Networks).map(([nwKey, networkMetrics]) => {
                return (_jsxs(Stack, { direction: 'column', sx: { width: '100%' }, children: [_jsxs(Box, { children: [nwKey.replace(/_/g, ' '), " "] }), _jsx(NetworkMetricsTable, { networkMetrics })] }, nwKey));
            }), showExport && (_jsx(RowColumnExport, { contextCustomer: undefined,
                object: coverageReport,
                rowColumnizer: spreadsheetize,
                spreadsheetTitle: `${GeoObject.name} ${getNiceDate(timePeriod.fromDateMs)} -  ${getNiceDate(timePeriod.toDateMs)}` }))] }));
};
export const GeoObjectTable = ({ GeoObject, timePeriod, created }) => {
    const { fromDateMs, toDateMs } = timePeriod;
    return (_jsxs(Stack, { direction: 'row', spacing: 1, children: [_jsx(Box, { children: GeoObject.name }), _jsx(Box, { children: `${getNiceDate(fromDateMs, { weekday: 'short', day: 'numeric', month: 'short', year: 'numeric' })} - ${getNiceDate(toDateMs, {
                    weekday: 'short',
                    day: 'numeric',
                    month: 'short',
                    year: 'numeric',
                })}` }), _jsx(Box, { children: `Created: ${getNiceDate(new Date(created).valueOf(), {
                    weekday: 'short',
                    day: 'numeric',
                    month: 'short',
                    year: 'numeric',
                })}` })] }));
};
const NetworkMetricsTable = ({ networkMetrics: { GatewayStats, Gateways } }) => {
    return (_jsx(Stack, { direction: 'column', sx: { width: '100%' }, children: Gateways.map((gw) => {
            const geofenceMetrics = GatewayStats[gw.eui ?? 'never'];
            return (_jsxs(Stack, { direction: 'row', sx: { width: '100%', marginTop: 1, borderTopStyle: 'solid', borderTopWidth: '0.5' }, children: [_jsxs(Stack, { children: [" ", gw.name || gw.eui] }), _jsx(GeofenceMetricsTable, { geofenceMetrics })] }, gw.eui));
        }) }));
};
export const GeofenceMetricsTable = ({ geofenceMetrics: { power, rssi, snr, sf, esp, dropped } }) => {
    const columns = '3em repeat(5, 2em)';
    return (_jsxs(Stack, { children: [_jsxs(Box, { width: '100%',
                display: 'grid',
                gridTemplateColumns: columns,
                gap: 1,
                sx: { paddingBlockEnd: 0.25, borderBlockEnd: (t) => `1px solid ${t.palette.divider}` }, children: [_jsx(Box, { textAlign: "center" }), _jsx(Box, { textAlign: "center", children: "#" }), _jsx(Box, { textAlign: "center", children: "Min" }), _jsx(Box, { textAlign: "center", children: "Mean" }), _jsx(Box, { textAlign: "center", children: "Max" }), _jsx(Box, { textAlign: "center", children: "S.D." })] }), Object.entries({ /*power*/ esp, rssi, snr, sf /*dropped*/ }).map(([k, cmv]) => {
                let name = k;
                switch (k) {
                    case 'power':
                        name = 'Power';
                        break;
                    case 'esp':
                        name = 'ESP';
                        break;
                    case 'snr':
                        name = 'SNR';
                        break;
                    case 'rssi':
                        name = 'RSSI';
                        break;
                    case 'sf':
                        name = 'SF';
                        break;
                    case 'dropped':
                        name = 'Dropped';
                        break;
                }
                if (cmv)
                    return (_jsxs(Box, { width: "100%", display: "grid", gridTemplateColumns: columns, gap: 1, children: [_jsx(Box, { sx: { paddingBlockStart: 0.25, borderInlineEnd: (t) => `1px solid ${t.palette.divider}` }, children: name }), _jsx(CMVTable, { cmv })] }, k));
            })] }));
};
const CMVTable = ({ cmv }) => {
    const { cn, mean, max, min, sqDiffFromMean } = cmv;
    const varPop = cn > 1 ? sqDiffFromMean / cn : 0;
    const sdPop = Math.pow(varPop, 0.5);
    return (_jsxs(_Fragment, { children: [_jsx(Box, { textAlign: "center", paddingBlockStart: 0.25, children: isNonNaNNumber(cn) ? Math.round(cn) : '-' }), _jsx(Box, { textAlign: "center", paddingBlockStart: 0.25, children: isNonNaNNumber(min) ? Math.round(min) : '-' }), _jsx(Box, { textAlign: "center", paddingBlockStart: 0.25, children: isNonNaNNumber(mean) ? Math.round(mean) : '-' }), _jsx(Box, { textAlign: "center", paddingBlockStart: 0.25, children: isNonNaNNumber(max) ? Math.round(max) : '-' }), _jsx(Box, { textAlign: "center", paddingBlockStart: 0.25, children: isNonNaNNumber(sdPop) ? Math.round(sdPop) : '-' })] }));
};
